import React, { useState } from 'react';
import { Table, Button } from 'react-bootstrap';
import './adhoc-reports.scss';

const AdHocReports = ({ reports = [] }) => {
  console.log('Ad-hoc Reports:', reports); // Debugging line to check data

  const [selectedReports, setSelectedReports] = useState([]);

  const handleCheckboxChange = (id) => {
    setSelectedReports(prev =>
      prev.includes(id) ? prev.filter(reportId => reportId !== id) : [...prev, id]
    );
  };

  const handleRequestReports = () => {
    console.log('Requested reports with IDs:', selectedReports);
    // Add logic to handle report requests
  };

  return (
    <div className='reportType-table'>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th style={{ width: '70%' }}>Report Name</th>
            <th style={{ width: '20%' }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {reports.length > 0 ? (
            reports.map(report => (
              <tr key={report.id}>
                <td>
                  <input
                      className='adhoc-checkbox'
                      type="checkbox"
                      style={{ marginLeft: '10px' }}
                      checked={selectedReports.includes(report.id)}
                      onChange={() => handleCheckboxChange(report.id)}
                  />
                  {report.name}
                </td>
                <td>{report.status}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="2">No reports available</td>
            </tr>
          )}
        </tbody>
      </Table>
      <Button variant="primary" onClick={handleRequestReports}>
        Request Reports
      </Button>
    </div>
  );
};

export default AdHocReports;
